<template>
  <div class="row">
    <div id="table" class="col-md-10 table-responsive" style="margin: auto; overflow: auto">
      <table class="table table-striped" id="fin_efedroi">
        <thead>
          <tr>
            <th scope="col">ΑΣΜ</th>
            <th scope="col">ΕΠΩΝΥΜΟ</th>
            <th scope="col">ΟΝΟΜΑ</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr :id="item.efsa" v-for="item in rows" :key="item.aa">
            <td>{{item.efsa}}</td>
            <td>{{item.efEpwnymo}}</td>
            <td>{{item.efOnoma}}</td>
            <td>
              <button
                type="button"
                class="btn btn-outline-danger"
                v-on:click.prevent="DeleteE(item.efsa)"
              >Αφαίρεση</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "Team Table",
  props: ["rows"],
  methods: {
    DeleteE: function(asm) {
        this.$props.rows = this.$props.rows.filter(e => e.efsa != asm);
        this.$emit('update:rows',this.$props.rows);
    }
  }
};
</script>